module.exports = __webpack_public_path__ + "img/subheader02_mid.4747c566.jpg";